import {useEffect, useRef} from 'react';

export const usePeriodicFetch = (
    shouldFetch: boolean,
    fetchAction: () => void,
    intervalSec: number) => {

    const fetchActionRef = useRef(fetchAction);
    fetchActionRef.current = fetchAction;

    useEffect(() => {
        if (!shouldFetch) return;

        fetchActionRef.current();
        const interval = setInterval(() => fetchActionRef.current(), intervalSec * 1000);

        return () => clearInterval(interval);
    }, [shouldFetch, intervalSec]);
};